import React, { useEffect, useState, Fragment, useRef } from 'react'
// import { Button, Col, div, Row } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import Loading from '../assetLibComponents/Loading'
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import { fetchUserList, deleteUser } from '../../redux/actions/settingActions';

const SettingUser = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null)
  const userListing = useSelector((state) => state.setting.fetchUserList);
  const isLoading = useSelector((state) => state.setting.loading);
  const [searchValue, setSearchValue] = useState("");
  const authToken = props.authToken;
  const [show, setShow] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const handleClose = () => {
    setDeleteData(null);
    setShow(false);
  };
  const handleShowPopup = (id) => {
    setShow(true);
    setDeleteData(id);
  };
  
  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };
  
  const deleteEvent = () => {
    dispatch(deleteUser(authToken, deleteData));
    handleClose();
  };
  
  useEffect(() => {
    dispatch(fetchUserList(props.authToken,""));
  }, []);

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(fetchUserList(props.authToken,e.target.value));
  }

  const handleCloseSearch = () => {
    setSearchValue("");
    dispatch(fetchUserList(props.authToken,""));
  }

  return (
     <>
      {isLoading && <Loading />}
        <>
        <div className="px-0">
          <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Users</div>   
            <div className="mt-4 max-sm:mt-0 sm:ml-16 sm:mt-0 sm:flex-none max-sm:w-[30%]">
              <button
                type="button"
                className="block rounded-md bg-[#64B6E7] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                onClick={() => {
                navigate(`/Setting/addUser`);
                // navigate(`/Lead-Management/addAccounts`);
                }}
              >
                + Add user
              </button>
            </div>            
          </div>
          <div className="flex items-center mt-4">
            <div className="sm:flex-auto">
              <div className="relative rounded-md shadow-sm my-auto w-[30%] max-sm:w-[70%]">
                <DebounceInput
                  value={searchValue}
                  className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                  placeholder="Search User..."
                  minLength={3}
                  debounceTimeout={500}
                  onChange={handleSearch}
                />
                <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                  {searchValue && searchValue !== "" ? (
                      <Icon.X className="h-4 w-4 text-gray-400 pointer" onClick={handleCloseSearch}/>
                    ) : (
                      <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch} />
                    )}
                </div>
              </div> 
            </div>
            
          </div>
          <div className="mt-6 max-sm:mt-4 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto listing sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-y-auto h-[60vh] max-sm:h-[70vh] bg-[#ffffff] listing shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50 sticky top-0 z-10">
                      <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          User
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Email
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Mobile
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Date
                        </th>
                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                          <span className="sr-only">Delete</span>
                        </th>
                      </tr>
                    </thead>
                    {userListing?.userList?.length > 0 && <tbody className="divide-y divide-gray-200 bg-white">
                      {userListing?.userList.map((user) => (
                        <tr key={user.email}>
                          <td className="flex items-center whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            <div className="bg-amber-100 rounded-[50%] flex w-8 h-8 flex-col justify-center items-center gap-[17.5px] shrink-0 p-[12.25px] mr-4">
                                <span className="capitalize text-amber-500 text-center text-base not-italic font-semibold leading-6">{getChars(`${user.first_name}${" "}${user.last_name}` || "Unknown")}</span>
                              </div>
                              <div className={"whitespace-nowrap block flex flex-col overflow-hidden text-ellipsis w-[60%] text-sm not-italic font-semibold leading-5" + (user?.email === "" ? " flex items-center ": "")}>
                               <span>{`${user.first_name}${" "}${user.last_name}`}</span> 
                               <span className='font-[400] text-xs'>{`${user.user_type === 3 ? "Admin" : ""}`}</span> 
                              </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500">
                            <div title={user.email} className='whitespace-nowrap overflow-hidden text-ellipsis w-[80%]'>{user.email}</div>  
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.mobile}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.date}</td>
                          {/* <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            
                          </td> */}
                          <td className="relative flex justify-center items-center whitespace-nowrap py-4 pl-3 pr-2 text-right text-sm font-medium sm:pr-2">
                            <span onClick={() => {navigate(`/Setting/editUser/${user.id}`);}} className="flex ml-auto mr-5 items-center justify-center px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                              <Icon.Pencil className="cursor-pointer text-gray-400 hover:text-[var(--brand-primary)] text-[16px]" />
                            </span>
                            <span className="text-[var(--brand-primary)] hover:text-indigo-900 cursor-pointer" onClick={() => {handleShowPopup(user.id);}}>
                              <Icon.Trash className='text-gray-400 hover:text-[var(--brand-primary)] text-[16px]' /><span className="sr-only">, {user.name}</span>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>}
                  </table>
                  {(userListing?.userList?.length === 0) && (
                    <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[10%] font-[bolder] font-add text-center">
                      <span className="flex justify-center text-[40px]">
                        <Icon.Inbox />
                      </span>
                      No Data
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
      <Transition.Root show={show} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete User(s)
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                               Are you sure you want to delete the user?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={deleteEvent}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={handleClose}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    </>
    )
}

export default SettingUser